import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'
import ProjectsIcon from '@components/Icon/ProjectsIcon'
import RenderField from '../Components/RenderField'
import '../Sidebar.sass'

class ClientContact extends Component {
  static propTypes = {
    id: PropTypes.number,
    clientStore: PropTypes.object,
    sidebarStore: PropTypes.object,
    staticData: PropTypes.object
  }

  constructor (props) {
    super(props)
    const { id } = this.props
    props.clientStore.getOffice(id)
  }

  handleClientOrOfficeNameClick = () => {
    const { sidebarStore } = this.props
    sidebarStore.closeSidebar()
  }

  renderClientContacts = clients => {
    if (clients.length < 1) return '-'
    return clients.map(client => {
      return (
        <p
          key={client.id}
          className='sidebar-wrapper__content__link'
          onClick={this.handleClientOrOfficeNameClick}
        >
          <NavLink to={`/client-contact-search/client-contact/${client.id}`}>
            {client.title} {client.fullName}
          </NavLink>
        </p>
      )
    })
  }

  renderParentAccountInformation = parentAccount => {
    return (
      <div>
        <RenderField
          label='Operational guidelines'
          html={parentAccount.operationalGuidelines || '-'}
        />
        <RenderField
          label='Disclaimer comment'
          value={parentAccount.disclaimerComment || '-'}
        />
        <RenderField
          label='Case code'
          value={parentAccount.caseCodeRequired ? 'Required' : 'Not required'}
        />
        <RenderField
          label='Show submitted expert names on client interface'
          value={parentAccount.expertsDisclosed ? 'Yes' : 'No'}
        />
      </div>
    )
  }

  render () {
    const { office } = this.props.clientStore

    if (!office) return null
    return (
      <div>
        <h1
          className='sidebar-wrapper__content__link'
          onClick={this.handleClientOrOfficeNameClick}
        >
          <NavLink to={`/office/${office.id}`}>{office.officeName}</NavLink>
        </h1>
        <div className='group'>
          <p>{office.account.companyName}</p>
        </div>
        <div className='group'>
          <div className='icon-label'>
            <ProjectsIcon />
            <p>{office.projects.length} Projects</p>
          </div>
        </div>
        <RenderField
          label='Address'
          value={
            <div>
              {office.address.address1 || office.address.address2 || '-'} <br />
              {office.address.city || '-'} <br />
              {office.address.state || '-'} <br />
              {this.props.staticData.getDataFromArray(
                office.address.countryId,
                'countries'
              ) || '-'}
            </div>
          }
        />
        <RenderField
          label='Client contacts'
          value={this.renderClientContacts(office.clients)}
        />
        <div>
          <h2>Parent account operational guidelines</h2>
          {this.renderParentAccountInformation(office.parentAccount)}
        </div>
      </div>
    )
  }
}

export default inject('sidebarStore', 'clientStore', 'staticData')(
  observer(ClientContact)
)
